import { ButtonsMenuItem } from "../../interfaces/Home/ButtonsMenuItem";
import { MenuItem } from "../../interfaces/Home/MenuItem";
import { SubMenuItem } from "../../interfaces/Home/SubMenuItem";
import { getIconDuotone, getIconRegular } from "../../utils/Icons";

export const middlewareMenuItems = (item: any): MenuItem => {
	const restricted = !!item.restricaoDeAcesso;
	const external = !!item.url;
	const children = (item.subMenu || []).map(middlewareSubMenuItems);
	const standalone = restricted || external || !children.length;
	const path = external ? item.url : '/' + (standalone ? item.component : getPathFromChildren(children));

	return {
		title: item.title || '',
		component: item.component || '',
		icon: getIconRegular(item.icon || ''),
		children,
		standalone,
		path,
		restricted,
		external,
	}
};

export const middlewareSubMenuItems = (item: any): SubMenuItem => {
	const external = !!item.url;
	return {
		title: item.title || '',
		subtitle: item.subTitle || '',
		component: item.component || '',
		path: external ? item.url : '/' + (item.component || ''),
		restricted: !!item.restricaoDeAcesso,
		buttons: (item.subMenu || []).map(middlewareButtonsMenuItems),
		external,
	}
};

export const middlewareButtonsMenuItems = (item: any): ButtonsMenuItem => {
	const external = !!item.url;
	return {
		title: item.title || '',
		component: item.component || '',
		path: external ? item.url : '/' + (item.component || ''),
		restricted: !!item.restricaoDeAcesso,
		external,
	}
};

export const middlewareAtalhosItems = (item: any): MenuItem => {
	const external = !!item.url;
	return {
		title: item.title || '',
		component: item.component || '',
		path: external ? item.url : '/' + (item.component || ''),
		icon: getIconDuotone(item.icon || ''),
		external,
		restricted: !!item.restricaoDeAcesso,
		standalone: true,
		children: [],
	}
};

const getPathFromChildren = (subMenuItems: SubMenuItem[]): string => {
	let path = ''
	const child = subMenuItems.find(c => !!c.path.length);
	if (child) {
		path = child.path.split('/')[1];
	}
	return path;
}
